import { ApiError, apiFetch } from './api-fetch.ts'

// JSON-first, same rationale as `alerts-api.ts`/`sessions-api.ts`/
// `registry-api.ts`: these interfaces cover the fields the panel itself
// reads/displays; the rest of each row rides through as JSON via the
// `[key: string]: unknown` tail.

export interface AllowedCommands {
  allow: string[]
  deny: string[]
}

export interface VaultEnvironmentRow {
  id: string
  name: string
  [key: string]: unknown
}

export interface VaultNodeResolveResult {
  nodeIds: (string | null)[]
}

export const qs = (params: Record<string, string | undefined>): string => {
  const search = new URLSearchParams()
  for (const [key, value] of Object.entries(params))
    if (value !== undefined) search.set(key, value)
  const query = search.toString()
  return query ? `?${query}` : ''
}

// ── environments ────────────────────────────────────────────────────────
export async function listEnvironments(
  rootId: string,
): Promise<VaultEnvironmentRow[]> {
  const { environments } = await apiFetch<{
    environments: VaultEnvironmentRow[]
  }>(`/vault/admin/${rootId}/environments`)
  return environments
}

export function createEnvironment(
  rootId: string,
  name: string,
): Promise<VaultEnvironmentRow> {
  return apiFetch<VaultEnvironmentRow>(`/vault/admin/${rootId}/environments`, {
    method: 'POST',
    body: JSON.stringify({ name }),
  })
}

export function resolveNodePaths(
  rootId: string,
  paths: string[],
): Promise<VaultNodeResolveResult> {
  return apiFetch<VaultNodeResolveResult>(
    `/vault/admin/${rootId}/nodes/resolve`,
    { method: 'POST', body: JSON.stringify({ paths }) },
  )
}

// `vaultFetch` is just the shared `apiFetch` under its historical name: the
// zod-issue unfolding this module's own parser did is now the shared
// default, so there is nothing vault-specific left in it. Kept as an alias
// because every sibling `vault-api-*.ts` module imports it from here, and
// `ApiError` is re-exported for importers that took it from this path.
export { apiFetch as vaultFetch, ApiError }
